import React from 'react';
import ErrorBoundary from '@atlassian/jira-error-boundary/src/ErrorBoundary.tsx';
import ReportErrors from '@atlassian/jira-errors-handling/src/utils/reporting-error-boundary.tsx';
import { lazyAfterPaint } from '@atlassian/react-loosely-lazy';
import { PACKAGE_NAME, TEAM_NAME } from './common/constants.tsx';

const AsyncRecommendPremiumToStandardModalComponent = lazyAfterPaint(() =>
	import(/* webpackChunkName:  "async-recommend-premium-to-standard-modal" */ './index.tsx').then(
		({ RecommendPremiumToStandardModalComponent }) => RecommendPremiumToStandardModalComponent,
	),
);

export const AsyncRecommendPremiumToStandardModalWrapper = () => {
	return (
		<ErrorBoundary id="recommend-premium-to-standard-modal-async" packageName={PACKAGE_NAME}>
			<ReportErrors
				teamName={TEAM_NAME}
				id="recommend-premium-to-standard-modal-async"
				packageName={PACKAGE_NAME}
			>
				<AsyncRecommendPremiumToStandardModalComponent />
			</ReportErrors>
		</ErrorBoundary>
	);
};
